exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-pro {\n  text-align: center;\n  font-size: 0.533333rem;\n  margin-top: 5.333333rem;\n}", ""]);

// exports
